import React from "react";
import { ContentBlock } from "@/types/case-study";

interface QuoteBlockProps {
  block: ContentBlock;
}

export const QuoteBlock: React.FC<QuoteBlockProps> = ({ block }) => {
  const text = block.content?.text || "";
  const author = block.content?.author || "";

  return (
    <div className="text-center py-4">
      <div className="max-w-4xl mx-auto">
        <blockquote className="text-xl md:text-2xl italic font-serif text-gray-800 leading-relaxed mb-4">
          <div dangerouslySetInnerHTML={{ __html: text }} />
        </blockquote>
        {author && (
          <div className="text-center">
            <cite className="text-sm font-bold text-gray-800 not-italic">
              {author}
            </cite>
          </div>
        )}
      </div>
    </div>
  );
};